<template>
    <el-input
        :placeholder="parseFloat(defaultCost)"
        :disabled="disabled"
        v-bind:value="parseFloat(newValue)"
        v-on:input="saveValue"
        class="inputWithSelect"
        type="number"
    >
        <p
            v-if="changeDetected"
            slot="suffix"
            class="default"
        >
            {{ defaultCost }}
        </p>
        <el-button
            slot="prepend"
            class="resetButton"
            style="width: 50px;"
            @click="resetAll"
        >
            <i
                v-if="!changeDetected"
                class="el-icon-check"
            ></i>
            <i
                v-else
                class="el-icon-upload2"
            ></i>
        </el-button>
    </el-input>
</template>

<script>
    export default {
        name: 'CostInput',
        props: {
            defaultCost: {
                type: Number,
                default: 0,
            },
            value:{
                type: Number,
                default: 0,
            },
            disabled: {
                type: Boolean,
                default: false,
            }
        },
        data(){
            return {
                newValue: undefined,
            }
        },
        computed:{
            changeDetected (){
                if(this.value !== this.defaultCost){
                    return true;
                }
                return false;
            }
        },
        watch: {
            defaultCost(val){
                if(val ===  parseFloat(this.newValue)){
                    this.newValue = undefined;
                }
            }
        },
        methods: {
            resetAll() {
                this.saveValue(this.defaultCost);
            },
            saveValue($event){
                this.newValue = $event
                if( parseFloat(this.newValue) ===  parseFloat(this.defaultCost)){
                    this.newValue = undefined;
                }
                this.$emit('input', parseFloat($event))
            }
        },
    }
</script>

<style lang="scss">
    .inputWithSelect {
        max-width: 200px;
        input:focus {
            border-color: #005BBA;
        }
        .resetButton:hover {
            color: #005BBA;
        }
        /* Chrome, Safari, Edge, Opera */
        input[type=number]::-webkit-outer-spin-button,
        input[type=number]::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        /* Firefox */
        input[type=number] {
            -moz-appearance: textfield;
        }

    }
    .resetButton{
        padding: 12px;
        .el-icon-upload2 {
            transform: rotate(-90deg);
        }
    }

    .default {
    text-decoration: line-through;
    line-height: 40px;
    margin: 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/partials/EnergeticGains/CostInput.vue